/**
 * 常量上下文：默认常量 + @app 应用层覆写
 * 1:1 还原参考项目 @pkg/diffconfig/src/diffConstants.js
 */
import appConstants from '@app/config/constants'
import standardConstants from './config/constants'
import { validateOverrides } from './validateOverrides'

validateOverrides('constants', standardConstants, appConstants)

const constants = { ...standardConstants, ...appConstants }
export default constants
